import { Resources } from 'constants/resources';

import { usePermissions } from 'hooks/usePermissions';
import { useRecordModal } from 'hooks/useRecordModal';
import { ApiClientsDeleteDialog } from 'pages/ApiClients/components/ApiClientsDeleteDialog/ApiClientsDeleteDialog';
import { useEditController, useNotify } from 'react-admin';
import { useNavigate } from 'react-router-dom';
import { DeleteButton, CancelButton, SaveButton } from 'shared/mui/Buttons';
import { EditGuesserPage } from 'shared/react-admin/Pages/EditGuesserPage/EditGuesserPage';
import { ApiClient } from 'types/embedded/apiClient';
import { Permission } from 'types/embedded/permission';

import { ApiClientsEditForm } from './ApiClientsEditForm';

const transform = (data: ApiClient): ApiClient => {
  return {
    ...data,
    merchant: data.merchant || null,
  };
};

export const ApiClientsEdit = () => {
  const { hasResourcePermissions } = usePermissions();
  const navigate = useNavigate();
  const notify = useNotify();
  const { record } = useEditController();
  const { handleCloseRecordModal, openRecordModal, handleOpenRecordModal } =
    useRecordModal<ApiClient>();

  return (
    <EditGuesserPage
      leftActionsSlot={
        hasResourcePermissions(Resources.ApiClients, [Permission.Full, Permission.Delete]) ? (
          <DeleteButton onClick={() => handleOpenRecordModal(record)} variant="outlined" />
        ) : undefined
      }
      listName="Клиенты API"
      mutationOptions={{
        onError: (error: Error) => {
          notify(`Ошибка: ${error.message || 'ошибка сервера'}`, {
            type: 'error',
            autoHideDuration: 3000,
          });
        },
      }}
      rightActionsSlot={[
        <CancelButton key="cancel-button" linkType="back" variant="outlined" />,
        <SaveButton key="save-button" />,
      ]}
      title="Редактирование Клиента API"
      transform={transform}
    >
      <ApiClientsEditForm />
      <ApiClientsDeleteDialog
        onClose={handleCloseRecordModal}
        onSuccess={() => navigate(-1)}
        open={openRecordModal}
        record={record}
      />
    </EditGuesserPage>
  );
};
